import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TouchAppIcon from "@material-ui/icons/TouchApp";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import TransitionsPopper from "./Popper"


const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: "#000c66",
  },
}));

export default function SingleRecipe(prop) {
  const classes = useStyles();
  const handleChildClick = (e) =>{
    e.stopPropagation();
  }

  return (
    <Card className={classes.root} style={{backgroundColor:"#a4e5e0"}}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            {prop.name[0]}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={prop.name}
        subheader={prop.noIngredients + "  Ingredients"}
      />
      <CardMedia
        className={classes.media}
        image={prop.image}
        title={prop.name}
      />
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          {prop.description}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <Button variant="body2" color="textSecondary" component="p">
          Try   recipe <TouchAppIcon/>
        </Button>
          
        </IconButton>
        <IconButton style={{marginBottom: "7px"}}    onClick={(e)=>handleChildClick(e)} aria-label="share">
         <TransitionsPopper id={prop.id}/> 
        </IconButton>
      </CardActions>

    </Card>
  );
}
